import { render, staticRenderFns } from "./PrefetchManyStoreEffect.vue?vue&type=template&id=37a8da6b&"
import script from "./PrefetchManyStoreEffect.vue?vue&type=script&lang=ts&"
export * from "./PrefetchManyStoreEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports